export const ACTION_MENU_ID = {
  HELLO_PACK: 4,
  FACT_FIND: 5,
};
